import { ScrollThrottler } from './utils';

const scrollThrottler = new ScrollThrottler();
const utilityNav = document.querySelector('.utility-nav');
const navBar = document.querySelector('.nav-bar');
const covidBand = document.getElementById('covid-band');

// transform: translateY(-21px);

let oldScrollPosition = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

function updateUtilityNav() {
  const newScrollPosition = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

  if (newScrollPosition < oldScrollPosition || newScrollPosition <= 0) {
    navBar.classList.remove('nav-bar--hide-utility');

    if (covidBand != null) {
      covidBand.classList.remove('nav-bar--hide-utility');
    }
  } else {
    navBar.classList.add('nav-bar--hide-utility');

    if (covidBand != null) {
      covidBand.classList.add('nav-bar--hide-utility');
    }
  }

  oldScrollPosition = newScrollPosition;
}

// Only attach this handler if we're showing the utility nav on the current page
if (utilityNav) {
  updateUtilityNav();
  scrollThrottler.add(updateUtilityNav);
}
